import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { motion } from 'framer-motion';
import styles from './styles.module.css';

const fadeUp = {
  hidden: { opacity: 0, y: 24 },
  visible: { opacity: 1, y: 0, transition: { duration: 0.6, ease: 'easeOut' } },
};

export default function FAQ() {
  const { t } = useTranslation('landing');
  const [openIndex, setOpenIndex] = useState(null);

  const faqs = t('faq.items', { returnObjects: true });
  const toggle = (i) => setOpenIndex(openIndex === i ? null : i);

  return (
    <motion.section
      id="faq"
      className={styles.section}
      initial="hidden"
      whileInView="visible"
      viewport={{ once: true, amount: 0.2 }}
      variants={fadeUp}
    >
      <div className={styles.container}>
        <div className={styles.center}>
          <span className={styles.tag}>{t('faq.tag')}</span>
          <h2 className={styles.title}>{t('faq.title')}</h2>
        </div>
        <div className={styles.list}>
          {faqs.map((faq, i) => {
            const open = openIndex === i;
            return (
              <div key={i} className={styles.item}>
                <button
                  className={`${styles.q} ${open ? styles.open : ''}`}
                  onClick={() => toggle(i)}
                >
                  {faq.q}
                  <span className={styles.arrow}>⌄</span>
                </button>
                <div className={`${styles.a} ${open ? styles.open : ''}`}>
                  <p>{faq.a}</p>
                </div>
              </div>
            );
          })}
        </div>
      </div>
    </motion.section>
  );
}
